<template>
    <el-dialog title="Öl-Check" :visible="value" width="90%" @close="$emit('input', false)">
        <el-form :model="form">
            <el-form-item class="mb-8" label="Datum des Checks">
                <el-date-picker
                    v-model="form.date"
                    type="date"
                    placeholder="Wähle ein Datum"
                    format="dd.MM.yyyy"
                    value-format="yyyy-MM-dd"
                    class="mb-16"
                />
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer u-flex u-flex--space-between">
            <el-button class="u-full-width" type="default" icon="el-icon-close" @click="$emit('input', false)">Abbruch</el-button>
            <el-button
                class="u-full-width"
                type="primary"
                icon="el-icon-check"
                :disabled="!isFormValid"
                :loading="isLoading"
                @click="onSubmit"
            >Speichern</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Appwrite from '@/assets/appwrite'

export default {
    props: {
        value: { type: Boolean, required: true },
    },

    data () {
        return {
            form: this.getEmptyForm(),
            isLoading: false,
        }
    },

    computed: {
        isFormValid () {
            return this.form.date
        },
    },

    methods: {
        getEmptyForm () {
            return { date: '' }
        },

        async onSubmit () {
            if (!this.isFormValid) return

            this.isLoading = true

            try {
                const id = Appwrite.ID.unique()
                await Appwrite.databases.createDocument(Appwrite.DB_NAME, 'oil_check', id, this.form)

                this.isLoading = false
                this.form = this.getEmptyForm()

                this.$emit('input', false)
                this.$emit('reload')

                this.$notify({
                    title: 'Nice!',
                    message: 'Die Daten wurden gespeichert',
                    type: 'success',
                })
            } catch (e) {
                this.$notify({
                    title: 'Error',
                    message: e.message,
                    type: 'error',
                })
                this.isLoading = false
            }
        },
    },
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
    padding-top: $spacing-unit-16;
    padding-bottom: 0;
}
</style>
